import { RankedMetric, RankingHeader, RankingRequest } from '@features/rankings/models/ranking.model'
import { parseCommonRankingRow } from '@features/rankings/utils/ranking-common.utils'
import { ComparableMetric, ListedMetric } from '@core/models/metric.models'
import { Team } from '@core/models/team.models'
import { TeamHolder } from '@pages/team/models/team.models'
import { Match } from '@core/models/match.models'
import { ContextMenuHolder } from '@core/models/context-menu.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parseTeamToRankingRequest = (
  team: Team,
  value: ListedMetric | ComparableMetric,
  mode: Aggregation
): RankingRequest => ({
  seasonId: team.seasonId,
  competitionId: team.competitionId,
  metricName: value.key,
  teams: [team.id],
  aggregationDataSource: mode
})

export const parseTeamRankingHeader = (metricKey: string, metricContext: Team, matchDay: number): RankingHeader => ({
  title: metricKey,
  imageA: metricContext.portraitLogo,
  textA: metricContext.shortName,
  imageB: metricContext?.competition?.isoTypeLogo,
  textB: metricContext?.competition?.officialName,
  placeholderA: PLACEHOLDER_IMAGES.TEAM,
  placeholderB: PLACEHOLDER_IMAGES.TEAM,
  matchDay
})

const buildTeamRankingRowStyle = (rankedMetric: RankedMetric, selectedValues: RankedMetric[], id: string): string => {
  return [
    'mcm-ranking__row',
    rankedMetric.isSelected ? 'selected' : null,
    rankedMetric.id === id ? 'home' : null,
    selectedValues.length > 1 && rankedMetric.id === selectedValues[0].id ? 'first-selected' : null,
    selectedValues.length > 1 && rankedMetric.id === selectedValues[1].id ? 'last-selected' : null
  ]
    .filter(Boolean)
    .join(' ')
}
export const parseTeamRankingRows = (rankedMetric: RankedMetric[], context: ContextMenuHolder): RankedMetric[] => {
  const selectedValues = (rankedMetric || []).filter((m) => m.isSelected)
  const teamContext = context as TeamHolder
  const matchContext = context as Match

  const id = matchContext?.homeTeam?.teamId ?? teamContext?.comparison?.teamA?.id ?? teamContext?.team?.id

  return (rankedMetric || []).map((m) => {
    const metric = parseCommonRankingRow(m, context)

    return {
      ...metric,
      imagePlaceholder: PLACEHOLDER_IMAGES.TEAM,
      styleClass: buildTeamRankingRowStyle(m, selectedValues, id)
    }
  })
}
